module.exports = require('./helpers/bundle-url').getBundleURL('7kNAC') + "../../../../83.108e4789.avif" + "?" + Date.now();